export function lcOperationsInquiryLink(organizationId: number): string {
  const params = new URLSearchParams({
    tab: 'operations',
    operationsSection: 'learners',
  })
  return `/organizations/${organizationId}?${params.toString()}`
}
